import React, {useState} from 'react';
import {Icon, Modal, Table} from 'semantic-ui-react';

export const TasksDetailsModal = ({order}) => {
  const [showTasksDetails, setShowTasksDetails] = useState(false);
  return (
    <Modal closeOnEscape={true} open={showTasksDetails}
      trigger={
        <div className="dot" onClick={() => setShowTasksDetails(true)}>
          {order?.tasksDetail?.length || 0}
        </div>}>
      <Modal.Header>
        <div className='header flex'>
          <h2 className='flex grow' style={{'margin': 0}}>Tareas orden: {order?.order}</h2>
          <Icon className='download' name='close' style={{'margin': 0, 'cursor': 'pointer'}}
            onClick={() => setShowTasksDetails(false)} />
        </div>
      </Modal.Header>
      <Modal.Content>
        <Table celled compact columns={3}>
          <Table.Header>
            <Table.HeaderCell>Tarea</Table.HeaderCell>
            <Table.HeaderCell>Descripción</Table.HeaderCell>
            <Table.HeaderCell>Observación</Table.HeaderCell>
          </Table.Header>
          <Table.Body>
            {
              order.tasksDetail.map((task, i) => {
                return (
                  <Table.Row key={i}>
                    <Table.Cell width={2}>{task.serviceCode3}</Table.Cell>
                    <Table.Cell>{task.description}</Table.Cell>
                    <Table.Cell>{order.observation}</Table.Cell>
                  </Table.Row>
                );
              }, order)
            }
          </Table.Body>
        </Table>
      </Modal.Content>
    </Modal>
  );
};

